import { useCreateRequest, useGetSentRequests } from '../../../api/query_hooks/request';
import { useGetArtworks } from '../../../api/query_hooks/artwork';
import { Button, ButtonGroup, Form, Modal, Spinner } from 'react-bootstrap';
import { useGetUsers } from '../../../api/query_hooks/user';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Thumbnail from '../../../components/images/thumbnail/Thumbnail';
import { getArtworkImageUrl } from '../../../api/endpoints';

const RequestList = ({selectedRequest}) => {

    const [show, setShow] = useState(false);

    const requestsQuery = useGetSentRequests();


    return (
        <>
            {requestsQuery.isLoading &&
                <div className='m-auto'>
                    <Spinner animation="border" role="status" aria-describedby="loading" />
                </div>
            }
            {requestsQuery.isError && 
                <div className='m-auto'>
                    {requestsQuery.error.response?.data}
                </div>
            }
            {requestsQuery.isSuccess &&
                <div className="bg-dark d-flex flex-column flex-grow-1 px-2 pt-2 rounded-bottom">

                    <NewRequestModal show={show} setShow={setShow} />

                    <ul className='bg-darker d-flex flex-column flex-grow-1 col-12 p-0 m-0 border border-black overflow-y-auto'>
                        {requestsQuery.data?.data.map((request, index) => (
                            <li key={index} className={(parseInt(request.id) === parseInt(selectedRequest)) ? 'bg-dark' : 'hov-bg-2'}>
                                <Link to={'/certificates/owner/requests/'+request.id} className='col-12 d-flex justify-content-between align-items-center px-4 py-2 border border-black'>
                                    <div className=''>
                                        <p>{request.toUser ? "To: "+request.toUser.username : "Open request"}</p>
                                        <p className='m-0'>Artwork: {request.artwork.title}</p>
                                    </div>
                                    <div>
                                        <p>{new Date(request.createdAt).toLocaleDateString()}</p>
                                        <p className="text-mini flex-center m-0 border border-white-50 rounded">{request.status}</p>
                                    </div>
                                </Link>
                            </li>
                        ))}
                        {!requestsQuery.data?.data.length &&
                            <p className='text-center my-auto'>You haven't sent out any requests yet</p>
                        }
                    </ul>

                    <div className="text-white-50 hov-text-light flex-end col-12 py-1">
                        <Button variant='dark' onClick={() => setShow(true)} className='flex-center gap-2 p-1 ps-2'>
                            <p className='text-mini text-white-50 user-select-none m-0'>New request</p>
                            <div className='d-flex border border-white-50 border-2 rounded'>
                                <box-icon color='#aaa' name='plus' ></box-icon>
                            </div>
                        </Button>
                    </div>

                </div>
            }
        </>
    );
};

const NewRequestModal = ({ show, setShow }) => {

    const [artwork, setArtwork] = useState('');
    const [recipient, setRecipient] = useState('');
    const [step, setStep] = useState(0);

    const artworksQuery = useGetArtworks();
    const usersQuery = useGetUsers();
    const createRequestMutation = useCreateRequest();

    useEffect(() => {
        if(!show) setStep(0);
    }, [show]);


    return (
        <Modal
            size="lg"
            scrollable 
            show={show}
            fullscreen="md-down"
            centered
            onHide={() => {
                setShow(false);
            }}>
            <Modal.Header className="bg-dark rounded-md-top" closeButton>
                <Modal.Title className='flex-center'>New request</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-dark">
                <Form className='overflow-y-auto'>

                    {step === 0 &&
                        <>
                            {artworksQuery.isLoading &&
                                <div className='m-auto'>
                                    <Spinner animation="border" role="status" aria-describedby="loading" />
                                </div>
                            }
                            {artworksQuery.isError && 
                                <div className='m-auto'>
                                    {artworksQuery.error.response?.data}
                                </div>
                            }
                            {artworksQuery.isSuccess &&
                                <>
                                    <h4 className='text-center mb-3'>Select an artwork</h4>
                                    <div className='flex-start flex-wrap'>
                                        {artworksQuery.data?.data.map((artwork, index) => {
                                            return (
                                                <Thumbnail
                                                    key={index}
                                                    as='button'
                                                    src={getArtworkImageUrl(artwork.images[0].path)}
                                                    alt={artwork.title}
                                                    className='w-25 p-1'
                                                    onClick={() => {
                                                        setArtwork(artwork.code);
                                                        setStep(1);
                                                    }}
                                                />
                                            )
                                        })}
                                    </div>
                                </>
                            }
                        </>
                    }

                    {step === 1 &&
                        <>
                            {usersQuery.isLoading &&
                                <div className='m-auto'>
                                    <Spinner animation="border" role="status" aria-describedby="loading" />
                                </div>
                            }
                            {usersQuery.isError && 
                                <div className='m-auto'>
                                    {usersQuery.error.response?.data}
                                </div>
                            }
                            {usersQuery.isSuccess &&
                                <div className='flex-center flex-column'>
                                    <h4 className='text-center mb-3'>Choose an expert</h4>
                                    <ul className='list-group col-12 border border-2 border-black'>
                                        {usersQuery.data?.data.map((user, index) => {
                                            return (
                                                <li 
                                                    key={index}
                                                    onClick={() => {
                                                        setRecipient(user.username);
                                                        setStep(2);
                                                    }}
                                                    className='border border-black'
                                                >
                                                    <Button
                                                        variant='dark'
                                                        className='flex-between col-12 px-3 py-3'
                                                    >
                                                        <span className='flex-center flex-column'>
                                                            <p className='text-mini mb-2'>username:</p>
                                                            <p className='text-small m-0'>{user.username}</p>
                                                        </span>
                                                        <span className='flex-center flex-column'>
                                                            <p className='text-mini mb-2'>email:</p>
                                                            <p className='text-small m-0'>{user.email}</p>
                                                        </span>
                                                        <span className='flex-center flex-column'>
                                                            <p className='text-mini mb-2'>joined:</p>
                                                            <p className='text-small m-0'>{new Date(user.createdAt).toLocaleDateString()}</p>
                                                        </span>
                                                    </Button>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                    <h4 className='text-center my-3'>or post an open request</h4>
                                    <Button
                                        variant='dark'
                                        onClick={() => {
                                            setRecipient(null);
                                            setStep(2);
                                        }}
                                        className='align-self-end mx-auto border-light'
                                    >
                                        Post open request
                                    </Button>
                                </div>
                            }
                        </>
                    }

                    {step === 2 &&
                        <div className='flex-center flex-column'>
                            <h4 className='text-center mb-3'>Review request</h4>
                            <div className='flex-center flex-column'>
                                <p>Artwork: {artwork}</p>
                                <p>Recipient: {recipient ? recipient : 'open request'}</p>
                            </div>
                            <Button
                                variant='dark'
                                onClick={() => {
                                    createRequestMutation.mutate({
                                        artworkCode: artwork,
                                        recipientUsername: recipient
                                    });
                                    setShow(false);
                                }}
                                className='col-4 border-secondary border-2 rounded'
                            >
                                Confirm
                            </Button>
                        </div>
                    }

                </Form>
            </Modal.Body>
            <Modal.Footer className="bg-dark flex-between rounded-md-bottom">
                <Button variant="dark" onClick={() => setShow(false)} className="border-secondary">Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RequestList;